import React from 'react';
import { Button } from '@mui/material';

const ThemeButton = ({ themeColor, children, sx, ...props }) => {
    const buttonStyle = {
        textTransform: "none",
        border: "none",
        backgroundColor: themeColor || "#1b9a9b",
        borderRadius: "50px",
        fontSize: "12px",
        color: "white",
        px: "20px",
        py: "10px",
        "&:hover": {
            boxShadow: '0 8px 16px 0 rgba(0,0,0,0.2)',
            transition: "0.4s",
        },
        ...sx,
    };

    return (
        <Button variant="outlined" sx={buttonStyle} {...props}>
            {children}
        </Button>
    );
};

export default ThemeButton;
